import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { TextareaAutosize } from '@mui/material'
import { useAppServices } from 'hook/services'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "500px",
    minHeight: '500px',
    height: 'auto',
    overflow: 'auto',
    bgcolor: 'background.paper',
    border: '2px  #000',
    boxShadow: 24,
    p: 4,
}
const ViewModel = ({ data }) => {
    const AppService = useAppServices()
    const [openAddProduct, setOpenAddProduct] = useState(false)
    useEffect(async () => { }, [])
    function AddProduct({ open, onClose }) {
        const [getApprove, setGetApprove] = useState(false);
        const [processing, setProcessing] = useState(false)

        const checkLoom = (loom) => {
            try {
                const url = new URL(loom);

                window.open(url, '_blank');
            } catch (error) {
                alert("Invalid Loom video URL.");
            }
        };

        const stripHtmlTags = (html) => {
            return html?.replace(/<\/?[^>]+(>|$)/g, ""); // Removes all HTML tags
        };

        const handleApproveSave = async (e) => {
            e.preventDefault()
            console.log('asdfdf', e)
            const payload = {
                name: e.target.name.value,
                description: e.target.description.value,
            }

            const { response } = await AppService.app.create({
                payload: payload,
            })

            if (response) {
                setProcessing(false)
                onClose()

                updateRequest({ request_status: 'approved' })
            }
        }

        const updateRequest = async (payload) => {
            const { response } = await AppService.updateRequest.update({
                payload: { ...payload, _id: data?._id },
            })
            if (response) {
                onClose()
                return true
            } else {
                return false
            }
        }

        return (
            <MDModal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <MDBox sx={style}
                    component={getApprove ? 'form' : 'div'}
                    onSubmit={getApprove ? handleApproveSave : undefined}>
                    <MDBox
                        display="flex"
                        flexDirection="column"
                        gap={3}
                    >
                        <MDTypography textAlign="center" variant="button" sx={{ fontSize: '19px', fontWeight: '500', width: '100%' }} >
                            {data?.app_name}
                        </MDTypography>

                        <MDBox>
                            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                                Name
                            </MDTypography>
                            {getApprove ?
                                <MDInput label="Name" name="name" fullWidth defaultValue={data?.title} />
                                :
                                <MDBox>
                                    <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '400' }} >
                                        {data?.title}
                                    </MDTypography>
                                </MDBox>
                            }
                        </MDBox>
                        <MDBox>
                            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                                Description
                            </MDTypography>
                            {getApprove ?
                                <MDBox>
                                    <TextareaAutosize
                                        type="text"
                                        name="description"
                                        minRows={3}
                                        style={{ width: '100%' }}
                                        defaultValue={stripHtmlTags(data?.description)}
                                    />
                                </MDBox>
                                :
                                <div dangerouslySetInnerHTML={{ __html: data?.description }} style={{ fontSize: '14px', fontWeight: '400' }} />
                            }
                        </MDBox>
                        <MDBox display="flex" justifyContent="space-between">
                            <MDTypography variant="button" sx={{ fontSize: '16px', fontWeight: '500' }} >
                                Request From
                            </MDTypography>
                            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '400' }} >
                                {data?.type} level
                            </MDTypography>
                        </MDBox>
                        <MDBox display="flex" justifyContent="space-between">
                            <MDTypography variant="button" sx={{ fontSize: '16px', fontWeight: '500' }} >
                                Company Id
                            </MDTypography>
                            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '400' }} >
                                {data?.company_id}
                            </MDTypography>
                        </MDBox>
                        {
                            data?.type == "location" &&
                            <MDBox display="flex" justifyContent="space-between">
                                <MDTypography variant="button" sx={{ fontSize: '16px', fontWeight: '500' }} >
                                    Location Id
                                </MDTypography>
                                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '400' }} >
                                    {data?.location_id}
                                </MDTypography>
                            </MDBox>
                        }
                        {
                            data?.loom_video &&
                            <MDBox display="flex" justifyContent="space-between">
                                <MDTypography variant="button" sx={{ fontSize: '16px', fontWeight: '500' }} >
                                    Loom Video
                                </MDTypography>
                                <MDButton
                                    variant="contained"
                                    color="info"
                                    size="small"
                                    type="button"
                                    onClick={() => checkLoom(data?.loom_video)} // Call function on click
                                >
                                    View
                                </MDButton>
                            </MDBox>
                        }
                    </MDBox>
                    <MDBox display="flex" gap={3} mt={3}>
                        {getApprove ?
                            <MDButton variant="contained" type='submit' color="success" size="small">
                                Save
                            </MDButton>
                            :
                            <MDButton variant="contained" type='button' color="success" size="small" onClick={() => {
                                setGetApprove(true)
                            }}>
                                Approve It
                            </MDButton>
                        }
                        <MDButton variant="contained" type="button" color="error" size="small" onClick={() => updateRequest({ request_status: 'rejected' })}>
                            Reject
                        </MDButton>
                    </MDBox>
                </MDBox>
            </MDModal >
        )
    }
    const closeAddProduct = () => {
        // if (subscription?._id)
        setOpenAddProduct(false)
    }
    const handlemodal = () => {
        setOpenAddProduct(true)
    }
    return (
        <>
            <MDButton
                variant="contained"
                color="warning"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={handlemodal}
            >
                View
            </MDButton>
            <AddProduct open={openAddProduct} onClose={closeAddProduct} />
        </>
    )
}

export default ViewModel
